import { render } from "./DropDownMenuButton.vue?vue&type=template&id=75e2151a"
import script from "./DropDownMenuButton.vue?vue&type=script&lang=js"
export * from "./DropDownMenuButton.vue?vue&type=script&lang=js"

import "./DropDownMenuButton.vue?vue&type=style&index=0&id=75e2151a&lang=css"
script.render = render

export default script